import React from 'react';
import { BsTelephoneFill, BsGeoAltFill } from 'react-icons/bs';
import logoMCF from '../assets/images/logo-mcf.png';
import './ReviewsPreview.css';

const ReviewsPreview = () => {
  const reviews = [
    {
      name: 'Precillia',
      avatarLetter: 'P',
      avatarColor: '#9B59B6', // Violet
      text: "Moniteurs à l'écoute, obtention du permis du premier coup pour ma fille, ils ne cherchent pas à vous rajouter des heures et vous préparent à l'examen avec sérieux. Merci Bilel pour votre patience et votre sérieux. Je recommanderai votre auto-école autour de moi.",
      rating: 5
    },
    {
      name: 'Rayan',
      avatarLetter: 'R',
      avatarColor: '#1ABC9C', // Turquoise/vert
      text: "Une auto-école au top ! L'apprentissage est sérieux, structuré et adapté, ce qui m'a permis de progresser rapidement en toute confiance. Les moniteurs sont patients, à l'écoute et toujours motivants. Je vous recommande fortement cette auto-école, qui m'a permis d'obtenir mon permis du 1er coup.",
      rating: 5
    }
  ];

  return (
    <section className="reviews-preview">
      <div className="container">
        <h2 className="section-title">Avis de Nos Élèves</h2>
        
        <div className="reviews-stats">
          <div className="rating-display">
            <span className="rating-number">4.7</span>
            <span className="rating-stars">★★★★★</span>
          </div>
          <p className="rating-source">Basé sur 136 avis Google</p>
        </div>

        <div className="reviews-grid">
          {reviews.map((review, index) => (
            <div key={index} className="review-card">
              <div className="review-header">
                <div 
                  className="review-avatar" 
                  style={{ 
                    backgroundColor: review.avatarColor,
                    color: 'white',
                    fontWeight: 'bold'
                  }}
                >
                  {review.avatarLetter}
                </div>
                <h3 className="review-name">{review.name}</h3>
              </div>
              <div className="review-rating">
                {'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}
              </div>
              <p className="review-text">"{review.text}"</p>
            </div>
          ))}
        </div>

        <div className="reviews-separator"></div>

        <div className="contact-info">
          <a href="tel:0952655019" className="contact-item">
            <BsTelephoneFill className="contact-icon" />
            <span>09 52 65 50 19</span>
          </a>
          <a href="https://maps.google.com/?q=19+Av.+Franklin+Roosevelt,+77290+Mitry-Mory" target="_blank" rel="noopener noreferrer" className="contact-item">
            <BsGeoAltFill className="contact-icon" />
            <span>19 Av. Franklin Roosevelt, 77290 Mitry-Mory</span>
          </a>
        </div>

        <div className="payment-info">
          <div className="payment-item">
            <div className="payment-3x-badge" aria-hidden="true">
              <span className="payment-3x-value">3×</span>
            </div>
            <div className="payment-content">
              <h3 className="payment-title">Paiement en 3 fois</h3>
              <p className="payment-description">Sans frais</p>
            </div>
          </div>
          <div className="payment-item" style={{ display: 'none' }}>
            <div className="payment-logo-wrapper">
              <img src={logoMCF} alt="Mon Compte Formation" className="payment-logo" />
            </div>
            <div className="payment-content">
              <h3 className="payment-title">Financement CPF</h3>
              <p className="payment-description">Possible</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ReviewsPreview;
